export const APP_NAME = 'Ent Public Web'

export const LOCAL_STORAGE_KEYS = {
  THEME: 'ent-public-web-theme',
  // NOTE: this literal is also hard-coded in index.html's Consent Mode v2
  // bootstrap (it runs before any module loads). Keep the two in sync.
  COOKIE_CONSENT: 'ent-public-web-cookie-consent',
} as const

// Shared easing curves
export const EASE_OUT: [number, number, number, number] = [0.33, 1, 0.68, 1]

// Font families
export const BODY_FONT = "'Inter', sans-serif"
export const HEADING_FONT = "'Sentient', Georgia, serif"

// Horizontal scrim: solid page-bg on the left fading to transparent on the
// right. Anchors left-aligned copy over the cymatic/rune scenes (company hero,
// company closing section, platform hero). `rgb` is the comma-separated left
// base color (defaults to the #1F1D17 page background); the right endpoint is
// always transparent.
export const horizontalScrim = (rgb = '31,29,23') =>
  `linear-gradient(90deg, rgba(${rgb},1) 0%, rgba(${rgb},0.5) 32%, rgba(7,54,28,0) 100%)`
